import './SchoolShowcaseSection.css';
import CourseCalendar from './courses-calender/CourseCalendar';
import Parcours from './formations/Parcours';
import SchoolCurriculumSection from './school-curriculumSection/SchoolCurriculumSection';
import SchoolHero from './school-hero/SchoolHero';
import SchoolAdmissionSection from './sshool-admissionSection/SchoolAdmissionSection';
import StudentsLifeSection from './students-life-section/StudentsLifeSection';

export default function SchoolShowcaseSection() {
	return (
		<>
			<SchoolHero />
			<section className='school-showcase'>
				<SchoolCurriculumSection />
				<SchoolAdmissionSection />
				<Parcours />
				{/*<CourseCalendar />
				<StudentsLifeSection />*/}
			</section>
		</>
	);
}
